export const VAS = {
  DYNAMICCURRENCYCONVERSION: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.DynamicCurrencyConversion',
      defaultMessage: 'Dynamic Currency Conversion'
    }
  },
  TRANSACTIONRISKANALYSIS: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.TransactionRiskAnalysis',
      defaultMessage: 'Transaction Risk Analysis'
    }
  },
  POSTOKENIZATION: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.PosTokenization',
      defaultMessage: 'POS Tokenization'
    }
  },
  CLICKANDCOLLECT: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.ClickNCollect',
      defaultMessage: "Click'n Collect"
    }
  },
  LOYALTY: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.Loyalty',
      defaultMessage: 'Alpha Bank Bonus Loyalty Program'
    }
  },
  CLICKTOPAY: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.ClickToPay',
      defaultMessage: 'Click To Pay'
    }
  },
  NETWORKTOKENIZATION: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.NetworkTokenization',
      defaultMessage: 'Scheme Tokenization'
    }
  },
  AFT: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.AFT',
      defaultMessage: 'AFT'
    }
  },
  PAYTOCARD: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.PayToCard',
      defaultMessage: 'Pay-to-card'
    }
  },
  MULTICURRENCY: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.MultiCurrency',
      defaultMessage: 'Multicurrency'
    }
  },
  GATEWAYCURRENCYVALIDATION: {
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.GatewayCurrencyValidation',
      defaultMessage: 'Currency Exchange Rate Validation'
    }
  },
  ACQUIRERAGREEMENT:{
    name: {
      id: 't.app.terminalsManagement.vasConfiguration.title.GreekInstallment',
      defaultMessage: 'Acquirer Agreement'
    }
  }
}
